import { consola } from 'consola'
import { onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { Capacitor } from '@capacitor/core'

/**
 * Composable для обработки навигации назад на страницах профиля
 */
export const useProfileNavigation = () => {
  const router = useRouter()
  let backButtonHandler: ((event: any) => void) | null = null

  /**
   * Обработчик кнопки "Назад" для страниц профиля
   */
  const handleProfileBackButton = (event: any) => {
    const currentRoute = router.currentRoute.value
    
    // Проверяем, на какой странице профиля мы находимся
    if (currentRoute.path === '/lk') {
      // На главной странице профиля - возвращаемся на главную
      router.push('/')
      event?.preventDefault?.()
      return
    }
    
    // На подстраницах профиля - возвращаемся в профиль
    if (currentRoute.path.startsWith('/lk/')) {
      router.push('/lk')
      event?.preventDefault?.()
      return
    }
    
    // На страницах privacy и policy - возвращаемся в профиль
    if (currentRoute.path === '/privacy' || currentRoute.path === '/policy') {
      router.push('/lk')
      event?.preventDefault?.()
      return
    }
    
    // На странице избранного - возвращаемся в профиль
    if (currentRoute.path === '/favorites') {
      router.push('/lk')
      event?.preventDefault?.()
      
    }
  }

  /**
   * Регистрирует обработчик кнопки "Назад" для страниц профиля
   */
  const registerProfileBackHandler = async () => {
    // Только для нативных платформ
    if (!Capacitor.isNativePlatform()) {
      consola.debug('🔙 useProfileNavigation: Skipping - not a native platform')
      return
    }
    
    backButtonHandler = handleProfileBackButton
    // Используем низкий приоритет, чтобы корзина и модальные окна обрабатывались первыми
    const { App } = await import('@capacitor/app')
    App.addListener('backButton', backButtonHandler)
  }

  /**
   * Удаляет обработчик кнопки "Назад"
   */
  const removeProfileBackHandler = async () => {
    // Только для нативных платформ
    if (!Capacitor.isNativePlatform()) {
      return
    }
    
    if (backButtonHandler) {
      const { App } = await import('@capacitor/app')
      App.removeListener('backButton', backButtonHandler)
      backButtonHandler = null
    }
  }

  /**
   * Автоматическая регистрация и удаление обработчика
   */
  const useProfileBackNavigation = () => {
    onMounted(() => {
      registerProfileBackHandler()
    })

    onBeforeUnmount(() => {
      removeProfileBackHandler()
    })
  }

  return {
    handleProfileBackButton,
    registerProfileBackHandler,
    removeProfileBackHandler,
    useProfileBackNavigation,
  }
}
